import { peekCached } from "@/lib/requestCache";
import { FEED_PAGE_SIZE } from "@/hooks/feedPagination";
import { api, feedListCacheKey } from "@/services/api";
import type { FeedListParams, FeedPaginatedResponse } from "@/types/feed";

import {
  feedFiltersToListParams,
  resolveFeedFilters,
} from "./feedKaiFilters";

/** Synchronously hydrate the /feed first page from a warm request-cache entry. */
export function peekFeedPage(
  params: FeedListParams,
): FeedPaginatedResponse | undefined {
  return peekCached<FeedPaginatedResponse>(
    feedListCacheKey({ ...params, limit: FEED_PAGE_SIZE }),
  );
}

/** Warm the Activity feed chunk payload on nav hover or splash landing. */
export function prefetchFeedPageData(): void {
  void api.getFeed(feedFiltersToListParams(resolveFeedFilters())).catch(() => {});
}
